// extracted by mini-css-extract-plugin
export default {"calculatorContainer":"remittance_calculator_calculatorContainer__EIzfX"};